import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  "searchHeading": {
    id: "pages.discover.searchHeading",
    defaultMessage: "Search for new courses",
    description: "Heading for the search section"
  },
  "searchPlaceholder": {
    id: "pages.discover.searchPlaceholder",
    defaultMessage: "Search...",
    description: "Placeholder text for search input"
  },
  "noResultsFound": {
    id: "pages.discover.noResultsFound",
    defaultMessage: "No results found",
    description: "Message shown when no search results are found"
  }
});

export default messages; 